import React, { Component, Fragment } from 'react'
import './style.scss'

export class LightSelect extends Component {
	constructor(props) {
		super(props)
		this.state = {
			active: false,
		}
	}

	handleOptionSelected = (option) => {
		this.setState({
			active: false,
		})
		this.props.onSelected(option)
	}
	renderOptions = () => {
		const { options, onChangeLabel } = this.props
		let counter = 1

		return options.map((option) => {
			return (
				<div
					onMouseDown={() => {
						this.handleOptionSelected(option)
					}}
					key={counter++}
					className="option">
					<input
						type="radio"
						className="radio"
						id={option.id}
						value={option.value}
					/>
					<label htmlFor={option.value}>{option.label}</label>
				</div>
			)
		})
	}

	toggleSelectedActive = () => {
		const { options } = this.props
		let newActive = false
		if (!!options && options.length > 0) {
			newActive = this.state.active ? false : true
		}
		this.setState({ active: newActive })
	}

	render() {
		const { active } = this.state
		const { selected, defaultValue, options } = this.props
		const hasOptions = !!options && options.length > 0
		const isSelected = !!selected && !!selected.label
		return (
			<div
				className="select-box"
				onBlur={() => {
					this.setState({ active: false })
				}}>
				<div
					className={
						active ? 'container-options active' : 'container-options'
					}>
					{hasOptions && this.renderOptions()}
				</div>
				<button
					type="button"
					onClick={this.toggleSelectedActive}
					className="selected">
					{isSelected ? selected.label : defaultValue}
				</button>
				<span className="down-arrow-separator-line" />
				<div className="down-arrow" />
			</div>
		)
	}
}
